import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: null,
    asideCollapseButton: false,
    meauCollapse: ['service', 'partner', 'report', 'admin'],
    fullPage: false,
    serviceList: [],
  },
  mutations: {
    setUserInfo(state, payload){
      state.userInfo = payload.userInfo;
    },
    setAsideCollapseButton(state, payload){
      state.asideCollapseButton = payload.isOpen;
    },
    setMeauCollapse(state, payload){
      state.meauCollapse = payload.open;
    },
    setFullPage(state, payload){
      state.fullPage = payload.fullPage;
    },
    setServiceList(state, payload){
      state.serviceList = payload.serviceList;
    }
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      reducer(val){
        return {
          userInfo: val.userInfo
        }
      }
    })
  ]
})
